

const $ = global.jQuery = require('jquery');
require('parsleyjs');

const parsleyOptions = {
    errorsWrapper: '<ul class="field__errors"></ul>',
    errorsContainer(parsleyField) {
        return parsleyField.$element.parents('.field');
    },
};

class Forms {

    constructor(element) {
        this.parsleyInstance = $(element).parsley(parsleyOptions);

        this.addEventListeners();
    }

    addEventListeners() {
        this.parsleyInstance.on('form:validated', () => {
            this.handleParsleyValidated();
        });
    }

    handleParsleyValidated() {
        if (!this.parsleyInstance.validationResult) {
            $('html, body').animate({
                scrollTop: this.parsleyInstance.$element.offset().top - 50,
            }, 150);
        }
    }
}

module.exports = Forms;



// WEBPACK FOOTER //
// ./source/scripts/components/forms.js